<template>
  <div v-once class="divider" :style="styleObject"></div>
</template>

<script>
export default {
  name: "divider",
  props: ["size"],
  computed: {
    styleObject: function() {
      return {
        height: this.size || "1em"
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.divider {
  display: block;
  width: 100%;
  clear: both;
}
</style>
